module.exports = __webpack_public_path__ + "img/symbol_8.9bc1e4fc.png";